import { combineActions, handleActions }   from 'redux-actions';
import { Map }                             from 'immutable';
import { ACTIONS, METHOD_GET, METHOD_PUT } from '../../../actions/utils/apiResources/apiResourceActions.const';
import { buildMethodsByActionGroup }       from '../../../actions/utils/apiResources/buildSyncActions';
import { prepareRequestKey }               from './prepareRequestKey';

const buildErrorsReducer = (resource) => {

  // Actions that will add items to the 'errors' state.

  const addActions = combineActions(
    buildMethodsByActionGroup[ACTIONS.CREATE](resource).failure,
    buildMethodsByActionGroup[ACTIONS.LIST](resource).failure,
    buildMethodsByActionGroup[ACTIONS.SHOW](resource).failure,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_GET).failure,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_PUT).failure,
    buildMethodsByActionGroup[ACTIONS.DEL](resource).failure,
  );


  // Actions that will remove items from the 'errors' state.

  const removeActions = combineActions(
    buildMethodsByActionGroup[ACTIONS.CREATE](resource).request,
    buildMethodsByActionGroup[ACTIONS.LIST](resource).request,
    buildMethodsByActionGroup[ACTIONS.SHOW](resource).request,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_GET).request,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_PUT).request,
    buildMethodsByActionGroup[ACTIONS.DEL](resource).request,
  );


  return handleActions(
    {

      [addActions](state, {payload: error, meta}) {

        const key = prepareRequestKey(meta);

        if (state.has(key)) {

          throw new Error(`Multiple calls to '${key} at the same time not allowed`);

        }

        return state.set(key, error);

      },

      [removeActions](state, {payload}) {

        const key = prepareRequestKey(payload);

        if (!state.has(key)) {

          return state;

        }

        return state.delete(key);

      },


    },

    Map()
  );

};

export default buildErrorsReducer;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/buildErrorsReducer.js